import { useAppDispatch, useAppSelector } from "@/app/hooks";
import AvatarDefault from "@/assets/images/avatarDefault.jpg";
import { getProfile } from "@/features";
import { useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

const UserProfile = () => {
  const { userInfo } = useAppSelector((state) => state.profile);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="mx-3">
                    <img
                      src={AvatarDefault}
                      alt=""
                      className="avatar-md rounded-circle img-thumbnail"
                    />
                  </div>
                  <div className="flex-grow-1 align-self-center">
                    <div className="text-muted">
                      <h5>
                        {userInfo?.first_name ?? ""} {userInfo?.last_name ?? ""}
                      </h5>
                      <p className="mb-1">Email: {userInfo?.email ?? ""}</p>
                      <p className="mb-0">Id No : #{userInfo?.id ?? ""}</p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserProfile;
